export default __webpack_public_path__ + "static/media/water.5d756eff.jpg";